export const FETCH_USER_SALES_REQUEST = '@salesTarget/FETCH_USER_SALES_REQUEST';
export const FETCH_USER_SALES_SUCCESS = '@salesTarget/FETCH_USER_SALES_SUCCESS';
export const FETCH_USER_SALES_FAILURE = '@salesTarget/FETCH_USER_SALES_FAILURE';
